import { createElement, FC } from 'react';
import Advanced from '@components/EntityDrawers/drawers/Conceptual/tabs/Advanced';
import Standard from '@components/EntityDrawers/drawers/Conceptual/tabs/Standard';
import { DrawerContentProps } from '@components/EntityDrawers/hocs/withDrawer';

export const ConceptualContent: FC<DrawerContentProps> = ({ tab }) => {
  return createElement([Standard, Advanced][tab ?? 0]);
};
